/* eslint-disable max-len */
import { ApolloError } from '@apollo/client';
import { getMachineOutput } from '../../../../api';
import { manageCodeLabelColumns } from '../../../../components';
import { machine } from '../../../../entityModel';
import { ManageMachinesTableBody } from './ManageMachineTableBody';
import { ManageMachinesTableHead } from './ManageMachineTableHead';

interface ManageMachinesTableProps {
  error?: ApolloError;
  loading: boolean;
  data?: getMachineOutput;
  onEdit: (machine: machine) => void;
  onDelete: (machine: machine) => void;
}

export const ManageMachinesTable = ({ error, loading, data, onEdit, onDelete, ...rest }: ManageMachinesTableProps) => {
  return (
    <table className="table table-bordered">
      <ManageMachinesTableHead
        columns={manageCodeLabelColumns}
      />
      <ManageMachinesTableBody
        columns={manageCodeLabelColumns}
        loading={loading}
        error={error}
        data={data}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </table>
  );
};
